module.exports = __webpack_public_path__ + "static/media/m15.16fb7a3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/merletto/m15.jpg
// module id = 436
// module chunks = 0